// Ontario cities grouped by region, replacing the flat ONTARIO_CITIES list for any new
// UI (instructor service-area selection, school HQ location) that needs region grouping.
// ontario-cities.ts is left in place, untouched, for any existing caller that still only
// needs a flat list — this file is additive, not a replacement of that one.

export interface OntarioRegion {
  region: string
  cities: string[]
}

export const ONTARIO_REGIONS: OntarioRegion[] = [
  {
    region: 'Greater Toronto Area',
    cities: [
      'Toronto', 'Mississauga', 'Brampton', 'Markham', 'Vaughan', 'Richmond Hill',
      'Oakville', 'Burlington', 'Milton', 'Halton Hills', 'Caledon', 'Pickering',
      'Ajax', 'Whitby', 'Oshawa', 'Clarington', 'Bowmanville', 'Newmarket',
      'Aurora', 'East Gwillimbury', 'Georgina',
    ],
  },
  {
    region: 'Golden Horseshoe / Niagara',
    cities: [
      'Hamilton', 'St. Catharines', 'Niagara Falls', 'Niagara-on-the-Lake',
      'Welland', 'Fort Erie', 'Port Colborne', 'Thorold', 'Pelham', 'Grimsby',
      'Lincoln', 'Cambridge', 'Kitchener', 'Waterloo', 'Guelph', 'Brantford',
    ],
  },
  {
    region: 'Eastern Ontario',
    cities: [
      'Ottawa', 'Kingston', 'Cornwall', 'Brockville', 'Pembroke', 'Petawawa',
      'Renfrew', 'Belleville', 'Quinte West', 'Napanee', 'Peterborough',
      'Kawartha Lakes', 'Cobourg', 'Port Hope',
    ],
  },
  {
    region: 'Southwestern Ontario',
    cities: [
      'London', 'Windsor', 'Sarnia', 'Chatham', 'Leamington', 'Amherstburg',
      'Essex', 'St. Thomas', 'Stratford', 'Woodstock', 'Ingersoll', 'Strathroy',
      'Tillsonburg', 'Norfolk County', 'Simcoe', 'Aylmer',
    ],
  },
  {
    region: 'Central Ontario (Simcoe / Muskoka / Kawarthas)',
    cities: [
      'Barrie', 'Orillia', 'Collingwood', 'Wasaga Beach', 'Midland',
      'Penetanguishene', 'Bradford', 'Innisfil', 'Gravenhurst', 'Huntsville',
    ],
  },
  {
    region: 'Northern Ontario',
    cities: [
      'Greater Sudbury', 'Sault Ste. Marie', 'Thunder Bay', 'North Bay',
      'Timmins', 'Kenora', 'Kirkland Lake', 'Elliot Lake', 'Owen Sound',
    ],
  },
]

export const ONTARIO_CITY_TO_REGION: Record<string, string> = Object.fromEntries(
  ONTARIO_REGIONS.flatMap(({ region, cities }) => cities.map(city => [city, region]))
)
